export enum FilterType {
  text = 0,
  date = 1,
  datetime = 2,
  number = 3,
  boolean = 4,
  enum = 5,
  autocomplete = 6,
}
